export const SLIDE_PADDING_BOX_TYPE_POSTER = 25;
export const SLIDE_PADDING_BOX_TYPE_EVENT = 12;
export const SLIDE_PADDING_BOX_TYPE_SCHEDULE = 0;
export const SLIDE_PADDING_BOX_TYPE_DEFAULT = 13;
export const DELAY_MOVE_FOCUS = 500;
export const SECTION_LIST_PAGE_LIMIT = 30;
